// extracted by mini-css-extract-plugin
module.exports = {"Control":"css-modules_Control__kdT7n","Track":"css-modules_Track__FwdnU","Indicator":"css-modules_Indicator__RkGFE","Thumb":"css-modules_Thumb__OOuG7"};